import { TableCell } from '@material-ui/core';
import React, { useContext } from 'react';
import { GenericTable, HeadCell } from '../../components/GenericTable';
import {
  TransactionsContext,
  TransactionsContextType,
} from '../../context/transactionsContext';

interface DepositProps {}

export const Deposits: React.FC<DepositProps> = (props): JSX.Element => {
  const { deposits, updateDepositsList } = useContext<TransactionsContextType>(
    TransactionsContext
  );

  React.useEffect(() => {
    (async () => {
      await updateDepositsList();
    })();

    return () => {};
  }, []);

  const depositsHeadCells: HeadCell[] = [
    { id: 'id', alignment: 'left', label: 'ID de retiro' },
    { id: 'amount', alignment: 'left', label: 'Cantidad' },
    {
      id: 'deposit_date',
      alignment: 'left',
      label: 'Fecha de depósito',
    },
    { id: 'method', alignment: 'left', label: 'Método' },
    { id: 'status', alignment: 'left', label: 'Estatus' },
    { id: 'user', alignment: 'left', label: 'Usuario' },
  ];

  return (
    <React.Fragment>
      <GenericTable
        tableName="Depósitos"
        rowsModel={deposits}
        headCells={depositsHeadCells}
        //onCheckboxClick={(checkboxes: string[]) => console.log(checkboxes)}
        tableCells={(row: number) => {
          return (
            <>
              <TableCell align="left"># {deposits[row].id}</TableCell>
              <TableCell align="left">{deposits[row].amount}</TableCell>
              <TableCell align="left">{deposits[row].deposit_date}</TableCell>
              <TableCell align="left">{deposits[row].method}</TableCell>
              <TableCell align="left">{deposits[row].status}</TableCell>
              <TableCell align="left">{deposits[row].user}</TableCell>
            </>
          );
        }}
      />
    </React.Fragment>
  );
};
